import React, { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import { LangContext } from '../../context/lang-context'
import useFetch from '../../hooks/fetchMSSQL-hook'
import NoResults from '../../components/NoResults/NoResults'
import moment from "moment";
import { NavigationContext } from '../../context/navigation-context'
import SearchFilter from '../../components/Filter/SearchFilter';

const ROS = () => {
  const { TRL_Pack } = useContext(LangContext)
  const { fetchMssqlApi } = useFetch()

  const { setHeaderData } = useContext(NavigationContext)

  const defaultFilter = {
    name: "ROS",
    page: 1,
    rowsPerPage: 50,
    sortBy: "none",
    dateTimeRangeFrom: moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
    dateTimeRangeTo: moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
    machineId: null,
    machineName: "",
    userId: null,
    userName: "",
    machineTags: { id: [], name: [] },
  }

  const [ROS, setROS] = useState([])
  const [filter, setFilter] = useState(defaultFilter);
  const [settingsFilter, setSettingsFilter] = useState({
    saveFilters: true,
    autoLoading: true,
    additionalFilter: true,
    flatView: false,
    rowsPerPage: 50,
  });

  const rowsPerPage = settingsFilter.rowsPerPage || filter.rowsPerPage || 50;

  const sortDefaults = {
    Created: "DESC",
    MachineFullName: "ASC",
    UnloadQuantity: "DESC",
  };

  const getSortState = () => {
    const [field, dir] = String(filter.sortBy || "").split("|");
    return { field, dir: (dir || "").toUpperCase() };
  };

  const sortState = getSortState();

  const arrow = (field) => {
    if (sortState.field !== field) return "";
    return sortState.dir === "ASC" ? " ▲" : " ▼";
  };

  const handleHeaderSort = (field) => {
    const [curField, curDirRaw] = String(filter.sortBy || "").split("|");
    const curDir = (curDirRaw || "").toUpperCase();

    let nextDir;
    if (curField === field) {
      nextDir = curDir === "ASC" ? "DESC" : "ASC";
    } else {
      nextDir = sortDefaults[field] || "ASC";
    }

    const next = { ...filter, sortBy: `${field}|${nextDir}`, page: 1 };
    setFilter(next);
    getROS(next);
  }

  const getMachineIdsByTags = (machineTagIds) => {
    return new Promise((resolve, reject) => {
      fetchMssqlApi(
        "tags/getMachineIdsByTags",
        { method: "POST", hideNotification: true, data: { machineTagIds } },
        (response) => { resolve(JSON.stringify(response.map(Number).filter(Number.isFinite)) || [])},
        (err) => reject(err)
      );
    });
  };

  const getROS = async (f) => {
    let machineIds = "[]";
    if (f?.machineTags?.id?.length > 0) { machineIds = await getMachineIdsByTags(f.machineTags.id)} 
    if (f?.machineId) {const arr = JSON.parse(machineIds); arr.push(Number(f.machineId)); machineIds = JSON.stringify(arr)}
    fetchMssqlApi('ros', {
      method: "POST",
      hideNotification: true,
      data: {
        fromCreateDateTime: f?.dateTimeRangeFrom,
        toCreateDateTime: f?.dateTimeRangeTo,
        machineIds: machineIds,
        createUserId: f?.userId,
        sortBy: f?.sortBy
      },
    }, response => {setROS(response)})
  }

  useEffect(() => {
    const screenHeight = window.innerHeight
    const reservedSpace = 350
    const visibleRows = Math.floor((screenHeight - reservedSpace) / 40)

    setFilter(prev => ({
      ...prev,
      rowsPerPage: visibleRows > 50 ? 50 : visibleRows,
    }))
  }, [])

  useEffect(() => {
    setHeaderData({text: TRL_Pack.ro.ros});
  }, [])

  return (
    <div>
        <div>
          <SearchFilter
            filterName="ROS"
            defaultFilter={defaultFilter}
            onFilterChange={(f) => setFilter(f)}
            onSettingsChange={(s) => setSettingsFilter(s)}
            search={getROS}
            totalCount={ROS.slice((filter.page - 1) * rowsPerPage, filter.page * rowsPerPage).length}
            dataList={ROS}
          />
          <div className="card">
            <h5 className="card-header">
              {TRL_Pack.ro.ros}
            </h5>
            <div
              className="overflow-auto custom-scroll"
              style={{
                maxHeight: `${window.innerHeight - 228}px`,
                overflowY: "auto",
              }}
            >
              {ROS.length ? (
                <table className="table table-striped">
                  <thead>
                    <tr className="text-center headers-color">
                      <td
                        style={{ cursor: "pointer", userSelect: "none" }}
                        onClick={() => handleHeaderSort("Created")}
                      >
                        RO <br />Czas zapisu, Żródło{arrow("Created")}
                      </td>
                      <td
                        style={{ cursor: "pointer", userSelect: "none" }}
                        onClick={() => handleHeaderSort("MachineFullName")}
                      >
                        {TRL_Pack.wi.MachineFullName}{arrow("MachineFullName")}
                      </td>
                      <td
                        style={{ cursor: "pointer", userSelect: "none" }}
                        onClick={() => handleHeaderSort("UnloadQuantity")}
                      >
                        Rozładowanie{arrow("UnloadQuantity")}
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {ROS
                      .slice(
                        (filter.page - 1) * rowsPerPage,
                        filter.page * rowsPerPage
                      )
                      .map((entry, idx) => (
                        <tr key={idx}>
                          <td>
                            <div className='d-flex flex-column justify-content-center align-items-center'>
                              {entry.RO !== '' && (
                                <Link to={`/ro/${entry.MachineInventoryId}`} className="btn text-nowrap btn-sm btn-outline-danger">
                                  RO {entry.MachineInventoryId}/{entry.Created.slice(5, 7)}/{entry.Created.slice(8, 10)}
                                </Link>
                              )}
                              <div className="btn">{entry.Created}</div>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex flex-column justify-content-center align-items-center text-center">
                              <Link to={`/machine/${entry.MachineId}`} className="btn btn-sm btn-outline-link">
                                {entry.MachineFullName}
                              </Link>
                            </div>
                          </td>
                          <td>
                            <div className='d-flex flex-column justify-content-center align-items-center'>
                              {entry.UnloadQuantity !== null && (
                                <div className="btn text-nowrap">{entry.UnloadQuantity} szt.</div>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              ) : (
                <NoResults />
              )}
            </div>
          </div>
        </div>
      </div>
  )
}

export default ROS;